import { CompactComposer } from "@design";
import { ArrowUp, MessageCircle } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import type { InitialPromptState } from "@/features/chat/useInitialPrompt";

/** The quick-question box: opens a new chat with the question sent. */
export function HomeAsk() {
  const { t } = useTranslation("home", { keyPrefix: "ask" });
  const navigate = useNavigate();
  const [value, setValue] = useState("");
  const send = () => {
    const prompt = value.trim();
    if (prompt) navigate("/chat", { state: { prompt } satisfies InitialPromptState });
  };
  return (
    <CompactComposer
      aria-label={t("label")}
      placeholder={t("placeholder")}
      leadingIcon={<MessageCircle />}
      sendIcon={<ArrowUp />}
      value={value}
      onChange={(event) => setValue(event.target.value)}
      onSend={send}
      sendDisabled={value.trim().length === 0}
    />
  );
}
